import * as React from 'react';
import PanelContext from '../PanelContext';
var HIDDEN_STYLE = {
  visibility: 'hidden'
};

function Header(_ref) {
  var prefixCls = _ref.prefixCls,
      _ref$prevIcon = _ref.prevIcon,
      prevIcon = _ref$prevIcon === void 0 ? "\u2039" : _ref$prevIcon,
      _ref$nextIcon = _ref.nextIcon,
      nextIcon = _ref$nextIcon === void 0 ? "\u203A" : _ref$nextIcon,
      _ref$superPrevIcon = _ref.superPrevIcon,
      superPrevIcon = _ref$superPrevIcon === void 0 ? "\xAB" : _ref$superPrevIcon,
      _ref$superNextIcon = _ref.superNextIcon,
      superNextIcon = _ref$superNextIcon === void 0 ? "\xBB" : _ref$superNextIcon,
      onSuperPrev = _ref.onSuperPrev,
      onSuperNext = _ref.onSuperNext,
      onPrev = _ref.onPrev,
      onNext = _ref.onNext,
      onCurrent = _ref.onCurrent,
      showTodayBtn = _ref.showTodayBtn,
      locale = _ref.locale,
      children = _ref.children,
      sourceMode = _ref.sourceMode,
      sourceModeCopy = _ref.sourceModeCopy,
      headerSelect = _ref.headerSelect;

  var _React$useContext = React.useContext(PanelContext),
      hideNextBtn = _React$useContext.hideNextBtn,
      hidePrevBtn = _React$useContext.hidePrevBtn,
      fieldid = _React$useContext.fieldid;

  var sourceModeCopyVar = sourceModeCopy ? sourceModeCopy : sourceMode;
  return /*#__PURE__*/React.createElement("div", {
    className: prefixCls
  }, onSuperPrev && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onSuperPrev,
    tabIndex: -1,
    className: "".concat(prefixCls, "-super-prev-btn"),
    style: hidePrevBtn ? HIDDEN_STYLE : {},
    title: sourceModeCopyVar === 'decade' ? locale.previousDecade : sourceModeCopyVar === 'year' ? locale.previousCentury : locale.previousYear // @ts-ignore
    ,
    fieldid: fieldid && "".concat(fieldid, "_super_prev_btn")
  }, superPrevIcon), onPrev && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onPrev,
    tabIndex: -1,
    className: "".concat(prefixCls, "-prev-btn"),
    style: hidePrevBtn ? HIDDEN_STYLE : {},
    title: locale.previousMonth // @ts-ignore
    ,
    fieldid: fieldid && "".concat(fieldid, "_prev_btn")
  }, prevIcon), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-view") // @ts-ignore
    ,
    fieldid: fieldid && "".concat(fieldid, "_view")
  }, headerSelect != undefined ? [headerSelect, children] : children), onNext && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onNext,
    tabIndex: -1,
    className: "".concat(prefixCls, "-next-btn"),
    style: hideNextBtn ? HIDDEN_STYLE : {},
    title: locale.nextMonth // @ts-ignore
    ,
    fieldid: fieldid && "".concat(fieldid, "_next_btn")
  }, nextIcon), onSuperNext && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onSuperNext,
    tabIndex: -1,
    className: "".concat(prefixCls, "-super-next-btn"),
    style: hideNextBtn ? HIDDEN_STYLE : {},
    title: sourceModeCopyVar === 'decade' ? locale.nextDecade : sourceModeCopyVar === 'year' ? locale.nextCentury : locale.nextYear // @ts-ignore
    ,
    fieldid: fieldid && "".concat(fieldid, "_super_next_btn")
  }, superNextIcon), showTodayBtn && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onCurrent,
    tabIndex: -1,
    className: "".concat(prefixCls, "-today-btn"),
    title: locale.today // @ts-ignore
    ,
    fieldid: fieldid && "".concat(fieldid, "_header_today_btn")
  }, locale.locale === 'zh-cn' ? '今' : locale.today));
}

export default Header;